export default "__VITE_ASSET__CJYE_r4J__"